export const ASIN_METRIC_TYPE = Object.freeze({
                                                NET_FA: 'NET_FA',
                                                NET_LA: 'NET_LA',
                                                FA_UNITS: 'FA_UNITS',
                                                LA_UNITS: 'LA_UNITS',
                                                NET_VAR_PER_UNIT: 'NET_VAR_PER_UNIT',
                                                ABS_VAR_PER_UNIT: 'ABS_VAR_PER_UNIT',
                                                SMAPE_VALUE: 'SMAPE_VALUE',
                                                NET_VARIANCE: 'NET_VARIANCE',
                                                ABS_VARIANCE: 'ABS_VARIANCE',
                                                WINSORIZED_NET_VARIANCE: 'WINSORIZED_NET_VARIANCE',
                                                WINSORIZED_ABS_VARIANCE: 'WINSORIZED_ABS_VARIANCE',
                                                WINSORIZED_NET_VAR_PER_UNIT: 'WINSORIZED_NET_VAR_PER_UNIT',
                                                WINSORIZED_ABS_VAR_PER_UNIT: 'WINSORIZED_ABS_VAR_PER_UNIT',
                                              });
export const COMPONENT_NAMES =
  Object.freeze({
                  associateFees: 'Associate Fees',
                  badDebt: 'Bad Debt',
                  closingFees: 'Closing Fees',
                  cogsAdjustment: 'Cogs Adjustments',
                  contributionProfit: 'Contribution Profit',
                  contributionProfitWithoutRefunds: 'Contribution Profit Without Refunds',
                  discretionaryCoop: 'Discretionary COOP',
                  displayAds: 'Display Ads',
                  freeReplacementCost: 'Free Replacement Cost',
                  fulfillmentFees: 'Fulfillment Fees',
                  giftwrapCost: 'Giftwrap COGS',
                  giftwrapRevenue: 'Giftwrap Revenue',
                  gms: 'Total GMS',
                  inboundFreight: 'Inbound Freight',
                  liquidationCost: 'Liquidation COGS',
                  liquidationRevenue: 'Liquidation Revenue',
                  otherCost: 'Other Costs',
                  otherRevenue: 'Other Revenue',
                  paymentFees: 'Payment Fees',
                  productCogs: 'Product COGS',
                  productGMS: 'Product GMS',
                  quickPayDiscounts: 'Quick Pay Discounts',
                  refundsCost: 'Refunds Cost',
                  refundsRevenue: 'Refunds Revenue',
                  revenueShare: 'Revenue Share',
                  salesDiscount: 'Sales Discounts',
                  sellerCredit: 'Seller Credits',
                  shippingCost: 'Shipping Cost',
                  shippingRevenue: 'Shipping Revenue',
                  sponsoredLinkFees: 'Sponsored Link Fees',
                  subscriptionRevenue: 'Subscription Revenue',
                  variableCSCost: 'Variable CS Costs',
                  variableFCCost: 'Variable FC Costs',
                  vendorAllowances: 'Vendor Allowances',
                  vendorReturns: 'Vendor Returns',
                  wdLiquidationCost: 'WD Liquidation Cost',
                  wdLiquidationRevenue: 'WD Liquidation Revenue'
                });

export const METRIC_NAMES =
  Object.freeze({
                  NET_FA: 'First Answer',
                  NET_LA: 'Last Answer',
                  FA_UNITS: 'FA: Units',
                  LA_UNITS: 'LA: Units',
                  NET_VAR_PER_UNIT: 'Net Variance Per Unit',
                  ABS_VAR_PER_UNIT: 'Abs Variance Per Unit',
                  NET_VARIANCE: 'Net Variance',
                  ABS_VARIANCE: 'Abs Variance',
                  WINSORIZED_NET_VARIANCE: 'Winsorized Net Variance',
                  WINSORIZED_ABS_VARIANCE: 'Winsorized Abs Variance',
                  WINSORIZED_NET_VAR_PER_UNIT: 'Winsorized Net Var Per Unit',
                  WINSORIZED_ABS_VAR_PER_UNIT: 'Winsorized Abs Var Per Unit',
                });

export const PER_UNIT_HISTOGRAM_DROPDOWN_ELEMENTS = [
  {
    label: METRIC_NAMES.NET_VAR_PER_UNIT,
    id: ASIN_METRIC_TYPE.NET_VAR_PER_UNIT,
  },
  {
    label: METRIC_NAMES.ABS_VAR_PER_UNIT,
    id: ASIN_METRIC_TYPE.ABS_VAR_PER_UNIT,
  }
];

export const TREND_CHART_DROPDOWN_ELEMENTS = [
  {
    label: METRIC_NAMES.NET_FA,
    id: ASIN_METRIC_TYPE.NET_FA,
  },
  {
    label: METRIC_NAMES.NET_LA,
    id: ASIN_METRIC_TYPE.NET_LA,
  },
  {
    label: METRIC_NAMES.NET_VAR_PER_UNIT,
    id: ASIN_METRIC_TYPE.NET_VAR_PER_UNIT,
  },
  {
    label: METRIC_NAMES.ABS_VAR_PER_UNIT,
    id: ASIN_METRIC_TYPE.ABS_VAR_PER_UNIT,
  },
  {
    label: METRIC_NAMES.WINSORIZED_NET_VAR_PER_UNIT,
    id: ASIN_METRIC_TYPE.WINSORIZED_NET_VAR_PER_UNIT,
  },
  {
    label: METRIC_NAMES.WINSORIZED_ABS_VAR_PER_UNIT,
    id: ASIN_METRIC_TYPE.WINSORIZED_ABS_VAR_PER_UNIT,
  }
];

export const ASIN_CHANNEL_TYPE_DROPDOWN_ELEMENTS = [
  {label: '1000',
    id: '1000'},
  {label: '1300',
    id: '1300'},
  {label: '1400',
    id: '1400'},
  {label: '1500',
    id: '1500'},
  {label: '1650',
    id: '1650'},
  {label: '2000',
    id: '2000'},
  {label: '6000',
    id: '6000'},
  {label: '6200',
    id: '6200'},
  {label: '6400',
    id: '6400'}
];

export const ASIN_MP_DROPDOWN_ELEMENTS = [
  {label: 'US',
    value: 'US',
    id: '1'}
];

export const HISTOGRAM_TYPE = Object.freeze({
                                              PERUNIT: 'PERUNIT',
                                            });

export const HISTOGRAM_METRICS = Object.freeze({
 PERUNIT: [ASIN_METRIC_TYPE.NET_VAR_PER_UNIT, ASIN_METRIC_TYPE.ABS_VAR_PER_UNIT],
})

export const DEFAULT_TREND_WEEKS = 52;
export const HISTOGRAM_DOWNLOAD_HEADINGS = ['Marketplace', 'Channel', 'TimeFrame', 'Product Line', 'Component', 'Metric', 'Bucket', 'ASIN Count'];



// WEBPACK FOOTER //
// ./src/constants/asin_metric_elements.jsx